import { SkipOrArgs } from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import {
    useCollectionMetadata,
    UseCollectionMetadataArgs,
} from './useCollectionMetadata';
import { useSelectedCollection } from './useSelectedCollectionSelectors';

export const useSelectedCollectionMetadata = () => {
    const { selectedCollection } = useSelectedCollection();

    const queryArgs: SkipOrArgs<UseCollectionMetadataArgs> = useMemo(() => {
        if (!selectedCollection) return skipToken;

        return {
            collectionId: selectedCollection.id,
            proscopeId: selectedCollection.proscopeId,
        } as UseCollectionMetadataArgs;
    }, [selectedCollection]);

    return useCollectionMetadata(queryArgs);
};
